import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import DashboardLayout from './pages/dashboard/DashboardLayout';
import LoginPage from './pages/login/login';
import './App.css';

const themeColors = {
  token: {
    colorPrimary: '#ffb86b', // logo主色
    colorBgBase: '#fff8ef', // 页面背景
    colorTextBase: '#4b2e13', // 主字体色
    colorBorder: '#e0e0e0', // 边框
    colorBgContainer: '#fff', // 卡片/内容背景
    colorLink: '#ff9800', // 链接色
    colorLinkHover: '#ffb86b',
    colorLinkActive: '#ff9800',
    borderRadius: 10, // 圆角更柔和
    fontSize: 15, // 全局字体略大
  },
  components: {
    Menu: {
      itemBg: '#fff8ef',
      itemSelectedBg: '#ffe1b2',
      itemColor: '#4b2e13',
      itemSelectedColor: '#4b2e13',
      itemHoverBg: '#fff2d6',
      itemHoverColor: '#ff9800',
    },
    Button: {
      colorPrimary: '#ffb86b',
      colorPrimaryHover: '#ff9800',
      colorText: '#4b2e13',
      colorTextDisabled: '#bfae9b',
      colorBorder: '#ffb86b',
    },
    Card: {
      colorBgContainer: '#fff',
      colorBorderSecondary: '#ffe1b2',
    },
    Input: {
      colorBgContainer: '#fff',
      colorText: '#4b2e13',
      colorBorder: '#ffb86b',
      colorBorderHover: '#ff9800',
      colorTextPlaceholder: '#bfae9b',
    },
    Avatar: {
      colorBg: '#ffe1b2',
      colorText: '#4b2e13',
    },
    Modal: {
      colorBgElevated: '#fff',
      colorText: '#4b2e13',
      colorPrimary: '#ffb86b',
    },
    Spin: {
      colorPrimary: '#ffb86b',
    },
    Typography: {
      colorText: '#4b2e13',
      colorLink: '#ff9800',
    },
  },
};

function App() {
  return (
    <ConfigProvider theme={themeColors}>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<DashboardLayout />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
